var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4843 -2913)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4843 2913)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4860.55 -3114)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.55 207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95,10.644,21.8,4.879,30.45,7.041v24.5L21.8,33.7,5.95,27.937,21.8,30.1V9.2L11.715,11.364V25.776L5.95,27.937Z",
    transform: "translate(-5.95 -4.879)",
    fill: "#e34b27"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuro);
export default __webpack_public_path__ + "static/media/ouro.c180616cdc6439df429698f2a415e379.svg";
export { ForwardRef as ReactComponent };